import { configureStore } from '@reduxjs/toolkit';

import admin from '@App/pages/Admin/admin.slice';
import app from '@App/app.slice';
import cookies from '@utils/Cookies/cookies.slice';
import filter from '@App/pages/Filter/filter.slice';
import map from '@App/components/Map/map.slice';
import vacancy from '@App/pages/JobVacancy/job-vacancy.slice';
import windowObserver from '@utils/WindowObserver/window-observer.slice';

const createStoreArgs = [];

if (import.meta.env.DEV) {
  const { createLogger } = await import('redux-logger');
  const logger = createLogger({
    collapsed: (_getState, _action, logEntry) => !logEntry.error,
  });

  createStoreArgs.push(logger);
}

const store = configureStore({ 
  reducer: {
    admin,
    app,
    cookies,
    filter,
    map,
    vacancy,
    windowObserver,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(createStoreArgs),
});

export default store
